import type { LevelPackManifest } from "#level-pack-schema";
import type { DeviceSettings } from "@-/dev.improve.haniverse.lib.device-settings";

export function getInstalledLevelPacks(
  _installed?: DeviceSettings["installedLevelPacks"],
): [
  string,
  { bytes: number; file: string; graphemes: string[]; revision: string; words: string[] },
][] {
  return [];
}
export function getLevelPackIdentity(_installed?: DeviceSettings["installedLevelPacks"]): string {
  return "web";
}
export function getLevelPackConnection(_identity: string): Promise<null> {
  return Promise.resolve(null);
}
export function fetchLevelPackManifest(): Promise<LevelPackManifest> {
  return Promise.reject(new Error("Offline packs are available in the mobile app"));
}
export function downloadLevelPack(
  _id: string,
  _options?: { onProgress?: (fraction: number | null) => void },
): Promise<void> {
  return Promise.reject(new Error("Offline packs are available in the mobile app"));
}
export function removeLevelPack(_id: string): Promise<void> {
  return Promise.resolve();
}
export function removeLegacyOfflineDatabase(): void {}
